import {
    ArrowBendUpLeft,
    Bank,
    Calculator,
    CalendarCheck,
    CalendarPlus,
    ChartLineUp,
    DeviceMobileCamera,
    type Icon,
    IdentificationBadge,
    IdentificationCard,
    Money,
    ShieldCheck,
    ShieldStar,
    ShootingStar,
    ShoppingBag,
    Storefront,
    TagChevron,
    UserCircle,
    UserCircleGear,
    Wallet,
} from '@phosphor-icons/react';

const freshdeskCategoriesIconMapper: { [key: string]: Icon } = {
    'Aion Bank': Bank,
    BIK: ShoppingBag,
    Raty: Money,
    Rejestracja: IdentificationCard,
    'Przelew weryfikacyjny': ShieldCheck,
    'Panel Klienta': UserCircle,
    'Zwrot lub anulowanie zamówienia': ArrowBendUpLeft,
    'Limit zakupowy': ChartLineUp,
    Płatności: Calculator,
    'Aktualizacja danych': UserCircleGear,
    'Aplikacja PayPo': DeviceMobileCamera,
    'Ocena zdolności kredytowej': ShieldStar,
    'Zapłać za 30 dni': CalendarPlus,
    'Zapłać w ratach': CalendarCheck,
    SmartPlan: ShootingStar,
    Nadpłaty: Wallet,
    'Paypo w sklepach stacjonarnych': Storefront,
    'Zastrzeżenie numeru PESEL': IdentificationBadge,
};

export const mapFreshdeskCategoriesIcons = (name: string): Icon =>
    freshdeskCategoriesIconMapper[name] || TagChevron;
